import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MemberStatusChange, MemberStatusCommand, MemberStatusOperation, MemberStatusTarget, statusBlocked, statusBusy } from '../domain/member-status';

@Component({ selector: 'app-member-status-dialog', imports: [FormsModule], templateUrl: './member-status-dialog.component.html' })
export class MemberStatusDialogComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) target!: MemberStatusTarget;
  @Input() operation?: MemberStatusOperation;
  @Input() returnFocus?: HTMLElement;
  @Output() submitted = new EventEmitter<MemberStatusCommand>();
  @Output() closed = new EventEmitter<void>();
  @ViewChild('dialog', { static: true }) dialog!: ElementRef<HTMLElement>;
  changeStatus: MemberStatusChange | null = null;
  expulsionReason = '';
  private hadModalOpen = false;
  get selectedMemberStatus(): number { return this.target.currentStatus; }
  get memberRemoveFlg(): boolean { return this.target.remove; }
  get busy(): boolean { return statusBusy(this.operation); }
  get blocked(): boolean { return statusBlocked(this.operation); }
  submit(form: NgForm): void {
    if (form.invalid || form.pending || this.blocked || this.changeStatus === null || (this.changeStatus === 2 && !this.expulsionReason.trim())) return;
    this.submitted.emit({ status: this.changeStatus, expulsionReason: this.expulsionReason });
  }
  close(): void { if (!this.busy) this.closed.emit(); }
  ngAfterViewInit(): void {
    this.hadModalOpen = document.body.classList.contains('modal-open');
    document.body.classList.add('modal-open');
    this.dialog.nativeElement.querySelector<HTMLInputElement>('input')?.focus();
  }
  ngOnDestroy(): void {
    if (!this.hadModalOpen) document.body.classList.remove('modal-open');
    if (this.returnFocus?.isConnected) this.returnFocus.focus();
  }
  @HostListener('document:keydown', ['$event']) keydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') { event.preventDefault(); this.close(); }
    if (event.key !== 'Tab') return;
    const nodes = [...this.dialog.nativeElement.querySelectorAll<HTMLElement>('button:not(:disabled),input:not(:disabled),[tabindex="0"]')]
      .filter(node => node.getClientRects().length > 0);
    if (!nodes.length) { event.preventDefault(); this.dialog.nativeElement.focus(); return; }
    const first = nodes[0], last = nodes[nodes.length - 1], current = document.activeElement;
    if (event.shiftKey && (current === first || !nodes.includes(current as HTMLElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (current === last || !nodes.includes(current as HTMLElement))) { event.preventDefault(); first.focus(); }
  }
}
